"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this.eventHandlers = {};
    }
    EventEmitter.prototype.on = function (event, handler) {
        var handlers = this.eventHandlers[event];
        if (handlers === undefined) {
            handlers = [];
            this.eventHandlers[event] = handlers;
        }
        handlers.push(handler);
        var unsubscribe = function () {
            var index = handlers.findIndex(function (element) { return element === handler; });
            if (index >= 0) {
                handlers.splice(index, 1);
            }
        };
        return unsubscribe;
    };
    EventEmitter.prototype.emit = function (event, data) {
        var handlers = this.eventHandlers[event];
        if (handlers) {
            handlers.forEach(function (handler) {
                handler(data);
            });
        }
    };
    return EventEmitter;
}());
exports.default = EventEmitter;
//# sourceMappingURL=EventEmitter.js.map